// extracted by mini-css-extract-plugin
export default {"container":"SidebarMenuItem_container__JZDqU","icon":"SidebarMenuItem_icon__m-kF7"};